/**
 * External Dependencies
 */
import 'jquery';
import gsap from 'gsap';
// import Splitting from 'splitting';
import SplitType from "split-type";

const teaserMain = document.querySelector('.front-hero');

if (teaserMain) {

	const frontHeroHeader = document.querySelector('.front-hero__header')
	const teaserLines = SplitType.create(frontHeroHeader, { types: "lines" });
	const teaserMainSummary = teaserMain.querySelectorAll('p');
	const teaserMainFigure = teaserMain.querySelector('.teaser__mask');
	const teaserMainImage = teaserMain.querySelector('img');
	const teaserMain_tl = gsap.timeline({ paused: true });
	teaserMain_tl
		.set([teaserMain, frontHeroHeader, teaserMainFigure], { opacity: 1 })
		.addLabel('figure')
		.fromTo(teaserLines.lines, { y: 50, 'clip-path': 'polygon(0px 100%, 100% 100%, 100% 100%, 0% 100%)' },
				{
					y: 0,
					'clip-path': 'polygon(0px 0%, 100% 0%, 100% 100%, 0% 100%)',
					duration: 1,
					ease: 'expo.inOut',
					stagger: 0.1,
				})
		.addLabel('words')
		.fromTo(
			teaserMainSummary,
			{ opacity: 0, y: 50 },
			{ opacity: 1, y: 0, duration: 1.5, ease: 'expo.inOut' },
			'<'
		)

	if (teaserMainFigure) {
		const figureTL = gsap.timeline();

		figureTL
			.fromTo(
				teaserMainFigure,
				{ 'clip-path': 'polygon(0px 100%, 100% 100%, 100% 100%, 0% 100%)' },
				{
					'clip-path': 'polygon(0px 0%, 100% 0%, 100% 100%, 0% 100%)',
					duration: 1.5,
					ease: 'expo.inOut',
				}
			)
			.fromTo(
				teaserMainImage,
				{ 'clip-path': 'polygon(0px 100%, 100% 100%, 100% 100%, 0% 100%)' },
				{
					'clip-path': 'polygon(0 0%, 100% 0%, 100% 100%, 0% 100%)',

					duration: 1.5,
					ease: 'expo.inOut',
				},
				'<+=.2'
			)
			;

		teaserMain_tl.add(figureTL, 'figure+=.1');
	}
	teaserMain_tl.play();
}



//hamburger
const hamburger = document.querySelector('.btn-hamburger');
const toggleAria = (aria) => {
	return aria === 'false' ? 'true' : 'false';
};

const toggleOffcanvas = () => {
	const aria = hamburger.getAttribute('aria-expanded'),
		offcanvas = document.querySelector('.offcanvas'),
		body = document.querySelector('body');
	hamburger.setAttribute('aria-expanded', toggleAria(aria));
	hamburger.classList.contains('hamburger--open')
		? hamburger.classList.remove('hamburger--open')
		: hamburger.classList.add('hamburger--open');
	offcanvas.classList.contains('open')
		? offcanvas.classList.remove('open')
		: offcanvas.classList.add('open');
	body.classList.contains('overflow-hidden')
		? body.classList.remove('overflow-hidden')
		: body.classList.add('overflow-hidden');
};

hamburger.addEventListener('click', toggleOffcanvas);

const offcanvasBg = document.querySelector('.offcanvas__bg');
offcanvasBg.addEventListener('click', toggleOffcanvas);

const hasSub = document.querySelectorAll(
	'.offcanvas-menu .menu-item-has-children > a'
);

hasSub.forEach((item) => {
	item.addEventListener('click', (e) => {
		e.preventDefault();
		console.log(e.target, 'skakke');
		e.target.classList.toggle('active');
	});
});

const toggleMobileNav = document.querySelector('.toggleMobileNav');

toggleMobileNav &&
	toggleMobileNav.addEventListener('click', () => {
		const aria = toggleMobileNav.getAttribute('aria-expanded');

		toggleMobileNav.setAttribute('aria-expanded', toggleAria(aria));

	});

const stickyObserver = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		const id = entry.target.getAttribute('id');

		const image = document.querySelector(`[data-sticky="${id}"]`);
		if (entry.isIntersecting) {
			// remove active pill
			const activePills = document.querySelectorAll('[data-pill-nav]');
			activePills.forEach((elm) => {
				elm.classList.remove('pills__link--active');
			});
			const activePill = document.querySelector(`[data-pill-nav="${id}"]`);
			image.classList.add('deck-pills__image--active');
			activePill.classList.add('pills__link--active');
		} else {
			const activePill = document.querySelector(`[data-pill-nav="${id}"]`);
			image.classList.remove('deck-pills__image--active');
			activePill.classList.remove('pills__link--active');
		}
	});
});
const deckPillsContent = document.querySelectorAll('.pillWatcher');
deckPillsContent &&
	deckPillsContent.forEach((elm) => {
		stickyObserver.observe(elm);
	});

let items = document.querySelectorAll('.intersect');

const itemDelay = 0.05;
function handler(entries, observer) {
	var itemLoad = 0;
	entries.forEach((entry) => {
		if (entry.intersectionRatio > 0) {
			const totalDelay = itemLoad * itemDelay;
			animate(entry.target, Math.round(totalDelay * 100) / 100);
			itemLoad++;
			observer.unobserve(entry.target);
		}
	});
}

const animate = (element, totalDelay) => {
	element.style.setProperty('--delay', totalDelay + 's');
	element.classList.add('loaded');
}
const observer = new IntersectionObserver(handler);

items.forEach((item) => {
	observer.observe(item);
});


const contentToggle = document.querySelector('.content-toggle__button');
const container = document.querySelector('.content-toggle__hidden');

contentToggle && contentToggle.addEventListener('click', function (event) {
	event.preventDefault();

	if (!container.classList.contains('show')) {
		container.classList.add('show');
		container.style.height = 'auto';

		let height = container.clientHeight + 'px';

		container.style.height = '0px';

		setTimeout(function () {
			container.style.height = height;
		}, 0);
	} else {
		container.style.height = '0px';

		container.addEventListener(
			'transitionend',
			function () {
				container.classList.remove('show');
			},
			{
				once: true,
			}
		);
	}
});
